module.exports = __webpack_public_path__ + "img/dropdown_not_selected.0b5451b3.svg";